/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { reportConfigsApi } from 'services/newApi/reportsConfigApi';
import { ReportConfigResponse } from 'services/types';

export interface CustomReportsState {
  selectedReportID?: string;
  reports: ReportConfigResponse[];
  isExitConfirmationVisible: boolean;
  modalRedirect?: string;
}

export const initialCustomReportState: CustomReportsState = {
  selectedReportID: undefined,
  isExitConfirmationVisible: false,
  reports: [],
  modalRedirect: undefined,
};

export const customReportsSlice: Slice<CustomReportsState> = createSlice({
  name: 'customReportsSlice',
  initialState: initialCustomReportState,

  reducers: {
    setSelectedId: (state, action: PayloadAction<string>) => {
      state.selectedReportID = action.payload;
    },

    setConfirmationVisible: (state, actions: PayloadAction<boolean>) => {
      state.isExitConfirmationVisible = actions.payload;
    },

    setModalRedirect: (state, actions: PayloadAction<string>) => {
      state.modalRedirect = actions.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      reportConfigsApi.endpoints.getReports.matchFulfilled,
      (state, action: PayloadAction<ReportConfigResponse[]>) => {
        state.reports = action.payload;

        if (
          !state.selectedReportID &&
          Array.isArray(action.payload) &&
          action.payload.length > 0
        ) {
          state.selectedReportID = action?.payload[0]?.reportConfigurationId;
        }
      }
    );
  },
});

export const { setSelectedId, setConfirmationVisible, setModalRedirect } =
  customReportsSlice.actions;
